<template>
  <main class="page-login d-flex align-items-center justify-content-center">
    <AwlModalCard title="Accedi" :border="false">
      <LoginForm disable-signup />
    </AwlModalCard>
  </main>
</template>

<script>

export default {
  name: 'page-login',
  components: {
    AwlModalCard: () => import('../../components/Card/AwlModalCard'),
    LoginForm: () => import('../../components/Account/LoginForm'),
  },
};
</script>

<style lang="scss">
.page-login {
  background-image: url($path-images + '/login-background.jpg');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  > * {
    position: relative;
    z-index: 1;
  }
  &::after {
    background: rgb(0,0,0);
    background: linear-gradient(0deg,rgba(0,0,0,.8),rgba($primary,.1));
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
}
</style>
